export const AUTH_TOKEN = 'auth-token'
export const USER = 'user'
export const PERMISSIONS = 'permissions'

// REACT_APP_GRAPHQL_ENDPOINT manda; sin ella, el build de producción va a api.laiten.app y npm start a localhost
export const GRAPHQL_ENDPOINT = process.env.REACT_APP_GRAPHQL_ENDPOINT ||
  (process.env.NODE_ENV === 'production' ? 'https://api.laiten.app' : 'http://localhost:4000')
export const GRAPHQL_WS_ENDPOINT = GRAPHQL_ENDPOINT.replace(/^http/, 'ws')
